import { FC } from "react";

import { onActivateKeyDown } from "@ryde/shared";

interface IProductionHubClickableCountProps {
  ids?: number[];
  count: number;
  onNavigate: (ids: number[]) => void;
  className?: string;
}

export const ProductionHubClickableCount: FC<
  IProductionHubClickableCountProps
> = ({ ids, count, onNavigate, className }) => {
  if (!ids?.length) {
    return <span>{count}</span>;
  }

  return (
    <span
      className={className ?? "preview-drawer-line__value--clickable"}
      role="button"
      tabIndex={0}
      onClick={() => onNavigate(ids)}
      onKeyDown={onActivateKeyDown(() => onNavigate(ids))}
    >
      {count}
    </span>
  );
};
